import { render, staticRenderFns } from "./TasksBank.vue?vue&type=template&id=774cc120&scoped=true"
import script from "./TasksBank.vue?vue&type=script&lang=js"
export * from "./TasksBank.vue?vue&type=script&lang=js"
import style0 from "./TasksBank.vue?vue&type=style&index=0&id=774cc120&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774cc120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774cc120')) {
      api.createRecord('774cc120', component.options)
    } else {
      api.reload('774cc120', component.options)
    }
    module.hot.accept("./TasksBank.vue?vue&type=template&id=774cc120&scoped=true", function () {
      api.rerender('774cc120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TasksBank.vue"
export default component.exports